/**
 * Created by sswaminathan on 10/8/22
 * File: ProductRegions
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { APP_ID_TO_NAME } from '../../../common/constants/LabelConstants'
import { isNonemptyArray } from '../../../common/utils/Utils'
import { DATA_REGION_DROPDOWN } from '../constants/TestingDataIds'
import DropDown from '../dropdown/DropDown'

const ProductRegions = (props) => {

  const { appRegion, appName, licenseValue, width, height, licenseInfo } = props
  const [disabled, setDisabled] = useState(false)

  const { setValue } = useFormContext()
  const fieldName = useMemo(() => {
    if (!isNonemptyArray(appRegion)) return
    const fieldName = (licenseValue && licenseValue.length) ? `${licenseValue}:region_name:${appName}` : `region_name:${appName}`
    setValue(fieldName, appRegion[0])
    return fieldName
  }, [appName, appRegion, licenseValue, setValue])

  useEffect(() => {
    if (licenseInfo && licenseInfo[appName]) {
      const regionValue = appRegion.find((each) => licenseInfo[appName]?.region === each.id)
      if (regionValue) {
        setDisabled(true)
      }
      setValue(fieldName, regionValue)
    }
  }, [appName, appRegion, licenseInfo, fieldName, setValue])

  return (
    <DropDown
      addClassName='cmm-modal-select'
      itemList={appRegion}
      fieldName={fieldName}
      dataTestId={DATA_REGION_DROPDOWN}
      errorLabel={`${APP_ID_TO_NAME[appName]} Region`}
      label={APP_ID_TO_NAME[appName]}
      required={true}
      width={width}
      disable={disabled}
      height={height}/>
  )
}

ProductRegions.propTypes = {}
export default ProductRegions
